/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import { saveAs } from 'file-saver'

// Store
import { actions } from 'core/store'

// Hooks
import { useDownloadReportsTravelRule } from 'core/hooks/api'

// Styled Elements
import {
  TableButtonWrapper,
  TableRowWrapper,
  TableRowContainer,
  TableText,
  StatusText,
} from './ReportsTravelRuleTableItem.elements'

// Constants
import { STANDARD_DATETIME_FORMAT, STANDARD_DATE_FORMAT } from 'common/constants/dateFormat'

// Views
import { TableItem, ButtonSplitSelect } from 'views/components'
import { useEffect } from 'react'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = (dispatch) => actions(dispatch)

function ReportsTravelRuleTableItem(props) {
  // Destructure
  const { data } = props
  const { showAlert } = actions
  const {
    created,
    start_range,
    end_range,
    status,
    id,
    // status_name
  } = data

  // Hooks
  const {
    downloadReportsTravelRule,
    downloadReportsTravelRuleData,
    downloadReportsTravelRuleError,
    isDownloadReportsTravelRuleLoading,
  } = useDownloadReportsTravelRule()

  // States
  const [format, setFormat] = useState('CSV')

  // function formatValue(number) {
  //   if (number < 1_000_000) {
  //     return numberWithCommas(Math.round(number * 100) / 100)
  //   }
  //   return compactNumberFormatter.format(number)
  // }

  // Constants
  const FORMAT_OPTIONS = [
    {
      value: 'CSV',
      onClick: () => setFormat('CSV'),
    },
    {
      value: 'JSON',
      onClick: () => setFormat('JSON'),
    },
    // {
    //   value: 'PDF',
    //   onClick: () => setFormat('PDF'),
    // },
  ]
  // Functions
  const handleDownload = () => {
    downloadReportsTravelRule({ format: format.toLowerCase(), id })
  }
  const downloadFile = (data, inputFormat) => {
    let blob
    if (inputFormat === 'CSV') {
      blob = new Blob([data], { type: `text/${inputFormat.toLowerCase()}; charset=utf-8` })
    }
    if (inputFormat === 'JSON') {
      blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' })
    }
    saveAs(blob, `Ospree_Report.${format.toLowerCase()}`)
  }
  // const downloadFile = (data, inputFormat) => {
  //   let blob
  //   // if (inputFormat === 'CSV') {
  //   //   blob = new Blob([data], { type: `text/${inputFormat.toLowerCase()}; charset=utf-8` })
  //   // }
  //   // if (inputFormat === 'JSON') {
  //   //   blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' })
  //   // }
  //   if (inputFormat === 'PDF') {
  //     blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' })
  //   }
  //   saveAs(blob, `Ospree_Report.${format.toLowerCase()}`)
  // }

  // UseEffect
  useEffect(() => {
    if (downloadReportsTravelRuleData) {
      downloadFile(downloadReportsTravelRuleData, format)
    }
  }, [downloadReportsTravelRuleData])
  useEffect(() => {
    // TODO ADD PROPER ERROR MSG SENT FROM SERVER
    if (downloadReportsTravelRuleError) showAlert({ type: 'error', message: 'An error occurred in fetching reports' })
  }, [downloadReportsTravelRuleError])
  return (
    <TableItem>
      {isDownloadReportsTravelRuleLoading ? (
        <TableButtonWrapper style={{ display: 'flex', justifyContent: 'center' }}>
          <TableText>Downloading...</TableText>
        </TableButtonWrapper>
      ) : (
        <TableButtonWrapper>
          <TableRowWrapper style={{ gridTemplateColumns: '1fr 0.7fr 2fr' }}>
            <TableRowContainer>
              <TableText>{created && moment(created).format(STANDARD_DATETIME_FORMAT)}</TableText>
            </TableRowContainer>
            <TableRowContainer>
              <TableText>TravelRule</TableText>
            </TableRowContainer>
            <TableRowContainer>
              <TableText>
                {start_range &&
                  end_range &&
                  `${moment(start_range).format(STANDARD_DATE_FORMAT)} - ${moment(end_range).format(
                    STANDARD_DATE_FORMAT
                  )}`}
              </TableText>
            </TableRowContainer>
          </TableRowWrapper>

          <TableRowWrapper style={{ gridTemplateColumns: '150px 1fr' }}>
            <TableRowContainer>
              <StatusText status={status === 2 && 'Completed'}>{status === 2 && 'Completed'}</StatusText>
            </TableRowContainer>

            <TableRowContainer>
              {status === 2 ? (
                <ButtonSplitSelect onClick={handleDownload} options={FORMAT_OPTIONS}>
                  {`Download (${format})`}
                </ButtonSplitSelect>
              ) : (
                <TableText>Available in a few minutes</TableText>
              )}
            </TableRowContainer>
          </TableRowWrapper>
        </TableButtonWrapper>
      )}
    </TableItem>
  )
}

// Default Props
ReportsTravelRuleTableItem.defaultProps = {
  address: {},
  actions: {},
  data: {
    id: '',
    created: '',
    report_type: '',
    start_range: '',
    end_range: '',
    status_name: '',
    status: 0,
  },
}

// Proptypes Validation
ReportsTravelRuleTableItem.propTypes = {
  address: PropTypes.shape({
    addressLinkDetails: PropTypes.shape({
      address_id: PropTypes.string,
    }),
    addressLinkData: PropTypes.shape({}),
  }),
  actions: PropTypes.shape({
    showAlert: PropTypes.func,
    setAddressLinkDetails: PropTypes.func,
  }),
  data: PropTypes.shape({
    id: PropTypes.string,
    report_url: PropTypes.string,
    created: PropTypes.string,
    report_type: PropTypes.string,
    start_range: PropTypes.string,
    end_range: PropTypes.string,
    status_name: PropTypes.string,
    status: PropTypes.number,
  }),
}
export default connect(mapStateToProps, mapDispatchToProps)(ReportsTravelRuleTableItem)
